// extracted by mini-css-extract-plugin
export default {"image-uploader":"image-uploader_image-uploader__XCqbd"};